import React from "react";
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> { variant?: string; }
export function Badge({ className = "", variant, ...props }: BadgeProps) {
  return <div className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors ${className}`} {...props} />;
}
